export default __webpack_public_path__ + "static/media/QC-4U-FRONT.42415b55.png";